// Regras puras da tela de Planos (/plans). A recorrência é do PLANO
// (`Plans.recurrence`); a empresa só a herda. Rótulos resolvem o i18n na
// chamada, para seguir o idioma atual.
import { i18n } from "../../translate/i18n";

export const RECORRENCIAS = ["MENSAL", "BIMESTRAL", "TRIMESTRAL", "SEMESTRAL", "ANUAL"];

// Desconhecida ou vazia vira MENSAL — é o que o backend assume.
export const recorrenciaCanonica = (recurrence) => {
  const r = String(recurrence || "").toUpperCase();
  return RECORRENCIAS.includes(r) ? r : "MENSAL";
};

// "/ mês", "/ trimestre"... — sufixo do preço no card do plano.
export const periodoLabel = (recurrence) =>
  i18n.t(`aeros.plans.period.${recorrenciaCanonica(recurrence)}`);

// "Mensal", "Trimestral"... — nome da recorrência.
export const recorrenciaLabel = (recurrence) =>
  i18n.t(`aeros.companies.recurrence.${recorrenciaCanonica(recurrence)}`);
